import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Antes empezaba desde cero cada semana… ahora tengo una estructura clara y avanzo mucho más rápido.',
  name: 'Laura M.',
  role: 'Docente de primaria'
}, {
  quote: 'Lo que más me ayudó fue el orden. Ya no siento que todo se me acumula.',
  name: 'Carlos R.',
  role: 'Docente de secundaria'
}, {
  quote: 'Por fin tengo organizados mis documentos, sesiones y evaluaciones en un solo sistema.',
  name: 'Ana G.',
  role: 'Docente de inicial, México'
}];
export function Testimonials() {
  return <section className="bg-brand-dark py-5 px-5" data-id="element-272">
      <div className="max-w-xl mx-auto" data-id="element-273">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-8" data-id="element-274">
          💬 ¿Qué dicen los docentes que ya usan el Megapack?
        </h2>

        <div className="space-y-4" data-id="element-275">
          {testimonials.map((t, i) => <div key={i} className="bg-gray-900 border border-gray-800 p-5 rounded-xl" data-id="element-276">
              <div className="flex gap-0.5 mb-3" data-id="element-277">
                {[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-brand-yellow text-brand-yellow" data-id="element-278" />)}
              </div>
              <p className="text-gray-300 italic text-sm mb-3 leading-relaxed" data-id="element-279">
                "{t.quote}"
              </p>
              <div data-id="element-280">
                <p className="font-bold text-white text-sm" data-id="element-281">{t.name}</p>
                <p className="text-xs text-gray-500" data-id="element-282">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}